import ListAjeerUpdate from "./ListAjeerUpdate";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAjeerData } from "../../../../../store/Api";
import { setAppError } from "../../../../../store/userSlice";

export default function AjeerUpdate() {
  const ajeerData = useSelector((state) => state.ajeerData);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");

  const [trigger,setTrigger] = useState();


  useEffect(() => {
    dispatch(getAjeerData(token));
  }, []);

  const updateData = () => {
    dispatch(getAjeerData(token));
  };

  return (
    <>
      <div className={`p-2 `}>
        <ListAjeerUpdate
          list={ajeerData.data?.data}
          loading={loading}
          titles={[
            "SR.NO.",
            "employee ID",
            "employee NAME",
            "CLIENT NAME",
            "VISA PROVIDER",
            "IQAMA NUMBER",
            "AJEER LOCATION ENGLISH",
            "AJEER LOCATION ARABIC",
            "AJEER APPLY DATE",
            "AJEER ISSUE DATE",
            "AJEER EXPIRE DATE",
            "AJEER VALID DAYS",
            "STATUS",
            "",
          ]}
          token={token}
          updateData={updateData}
        />
      </div>
    </>
  );
}
